import React from 'react';
import { useSonTranslation } from '../../../../../translation/useSonTranslation';
import {
  ImageUploadDescription,
  ImageUploadHeadline,
} from '../../../../../_lib/components/ImageUpload';
import { Row, Textarea, TextAreaParam, TextParam } from '../../../../../_lib/Form2';
import { TeaserImageUpload } from '../../../../../_lib/Form2/elements/ImageUpload/TeaserImageUpload';
import { formParamsUtils } from '../../../../../_lib/Form2/utils/formParamsUtils';
import { NestedParam } from '../../../../../_lib/Form2/types/NestedParam';
import { ImageFileParam } from '../../../../../_lib/Form2/types/FileUploadParam';
import IConstraints from '../../../../../types/IContraints';
import { murmurhash } from '../../../../../lib/js/hash';

type TeaserInformationPropertiesProps = {
  fetchUrl?: string;
  imageUploadParams: NestedParam<'imageuploadparams', 'imageupload',
      TextParam<'alt'> | TextParam<'copyright'> | ImageFileParam<'image'>>;
  teaserTextParam: TextAreaParam<'teaserText'>;
};

export function TeaserInformationFormTemplate({
  fetchUrl,
  imageUploadParams,
  teaserTextParam,
}: TeaserInformationPropertiesProps) {
  const { t } = useSonTranslation('TeaserInformation');
  const image = formParamsUtils(imageUploadParams).getByName('image');

  return (
    <>
      <ImageUploadHeadline headlineHierarchy={4} />
      <ImageUploadDescription constraints={image.constraints as IConstraints} />
      <TeaserImageUpload key={murmurhash(imageUploadParams)} param={imageUploadParams} fetchUrl={fetchUrl} />
      <Row>
        <Textarea
          key={murmurhash(teaserTextParam)}
          label={t('teaserTextLabel')}
          param={teaserTextParam}
        />
      </Row>
    </>
  );
}
